/**
 * Default values for all i18n keys used by the lightweight in-app
 * dictionary store. Add new keys here as we extract more hardcoded
 * strings.
 *
 * The values here are the original Russian copy shipped with the
 * product. Users (or admins) can override any key at runtime via
 * the meme term selector in the header.
 *
 * `equipment.label` — «Энергетическая установка», и это ПРОВЕРЕНО ПО ИСТОРИИ, а не по памяти
 * (31.08.2026). Днём ранее умолчание развернули на «Энергетическое оборудование» с доводом, что
 * продукт на остальных экранах говорит «оборудование»; счёт живых строк этого не подтверждает:
 *
 *  - умолчание стоит «установкой» с 25.05.2026 и до того дня не менялось ни разу;
 *  - до начала работ над кабинетом (18.08.2026) фронт говорил «установка» девятнадцать раз
 *    против одного «оборудования» — и то единственное стояло в переключателе терминов шапки
 *    с подписью «было до этого»;
 *  - сегодня фронт: 92 против 39, бэкенд: 50 против 3.
 *
 * «Оборудование» — предыдущее имя, от которого ушли; оставшиеся строки админки просто не
 * переведены на этот ключ. Умолчание здесь и есть канонический термин: экран, которому нужно
 * слово, читает ключ, а не строку, и заказчик по-прежнему переименовывает его из шапки.
 */
export const I18N_DEFAULTS = {
  'equipment.label': 'Энергетическая установка',
} as const;

export type I18nKey = keyof typeof I18N_DEFAULTS;
